import React, { Component } from "react";
import { alert, loading, t } from "../../components/CustomComponent.js";
import { withRouter } from "../../components/withRouter.js";

import HomeNavbar from "./components/HomeNavbar.js";
import HomeFooter from "./components/HomeFooter.js";
import PartnerStepper from "./components/PartnerStepper.js";
import PartnerProfile from "./components/PartnerProfile.js";
import PartnerVerify from "./components/PartnerVerify.js";
import PartnerTerms from "./components/PartnerTerms.js";
import PartnerDone from "./components/PartnerDone.js";

import ICON from "./icons.js";
import { openFreePost, openPartnerStatus } from "./options.js";
import {
  DOC_SLOTS,
  EMPTY_PARTNER_FORM,
  PARTNER_STEPS,
  STEP_INDEX,
  firstInvalidStep,
  toApplyPayload,
  validateProfile,
  validateTerms,
  validateVerify,
} from "./partner_option.js";
import { applyPartner, uploadDocument, uploadPicture } from "../../services/partner.service.js";
import "../../assets/css/bootstrap.css";
import "../../assets/css/style.css";
import "../../assets/css/homepage.css";
import "../../assets/css/partner.css";

/* ============================================================================
 * PartnerApply — สมัครเป็นพาร์ตเนอร์ (/partner)
 *
 * เป็นหน้าเต็มไม่ใช่ป๊อปอัป เพราะฟอร์มยาว 3 ขั้นและมีการอัปโหลดเอกสาร — บนมือถือ
 * ป๊อปอัปจะเลื่อนซ้อนกันจนกรอกยาก และหน้าเต็มมี URL ของตัวเองให้ส่งต่อ/บุ๊กมาร์กได้
 *
 * ขั้นตอน (ดู partner_option.js)
 *   1. profile  ข้อมูลส่วนตัว ที่อยู่ ประสบการณ์
 *   2. verify   ยืนยันอีเมลด้วย OTP + อัปโหลดเอกสารยืนยันตัวตน
 *   3. terms    ตรวจทานข้อมูล + ยอมรับข้อกำหนดและความยินยอม PDPA
 *   4. done     ส่งแล้ว รอผู้ดูแลระบบตรวจสอบและอนุมัติ
 *
 * ต่อกับ API แล้ว (services/partner.service.js) :
 *   POST partner/otp/request · partner/otp/verify   ยืนยันอีเมล → ได้ตั๋วใบสมัคร
 *   POST partner/upload/presign                     อัปเอกสารตรงเข้า R2 (ต้องมีตั๋ว)
 *   POST partner/apply                              ส่งใบสมัคร (ต้องมีตั๋ว)
 * เลขที่ใบสมัครมาจากหลังบ้าน ไม่ได้ออกเองในเครื่อง
 *
 * ไฟล์เอกสารและรูปโปรไฟล์ถูกอัปขึ้นตอนกดส่งเท่านั้น ไม่ใช่ตอนเลือกไฟล์ — คนที่เลือก
 * ไฟล์แล้วเปลี่ยนใจปิดแท็บไปจะได้ไม่ทิ้งสำเนาบัตรประชาชนค้างอยู่ในบักเก็ตโดยไม่มี
 * ใบสมัครผูกอยู่ (และตอนเลือกไฟล์ยังไม่มีตั๋ว จะอัปก็ยังอัปไม่ได้อยู่ดี)
 *
 * ไม่เก็บร่างลง localStorage โดยตั้งใจ — ใบสมัครมีเลขบัตรประชาชนและสำเนาเอกสาร
 * ไม่ควรค้างอยู่ในเครื่องที่อาจใช้ร่วมกัน ใช้การเตือนก่อนปิดแท็บแทน
 * ตั๋วใบสมัครก็เก็บใน state ของหน้าเท่านั้นด้วยเหตุผลเดียวกัน (มันแลกเป็นสิทธิ์
 * อัปไฟล์เข้าบักเก็ตของระบบได้)
 * ========================================================================== */
class PartnerApply extends Component {
  state = {
    step: "profile",
    form: { ...EMPTY_PARTNER_FORM },
    errors: {},
    sending: false,
    ref_code: "",
    /* ตั๋วที่ได้ตอนยืนยัน OTP สำเร็จ — PartnerVerify ส่งขึ้นมาผ่าน setForm
       เก็บแยกจาก form เพราะไม่ใช่ข้อมูลที่ผู้ใช้กรอก และต้องไม่หลุดเข้าไปใน
       payload โดยบังเอิญตอน spread ฟอร์มทั้งก้อน */
    apply_token: "",
  };

  componentDidMount() {
    document.title = `${t("partner_title")} | SafeSpace Life Living`;
    /* ตัวหมุนโหลด (#loading ใน index.js) ขึ้นคลุมทั้งจอมาตั้งแต่เปิดเว็บ ทุกหน้าต้องสั่งปิดเอง
       หน้านี้เป็นฟอร์มเปล่า ไม่ได้ยิง API ตอนเปิด จึงไม่มีใครปิดให้ ถ้าไม่ปิดตรงนี้
       คนที่เปิดลิงก์นี้ตรง ๆ (เมนู ฟุตเตอร์ หรือปุ่มในหน้าผู้ดูแล) จะเจอฉากทึบค้างคาหน้า */
    loading(false);
    window.scrollTo({ top: 0 });
    window.addEventListener("beforeunload", this.onLeave);
  }

  componentWillUnmount() {
    window.removeEventListener("beforeunload", this.onLeave);
    // คืนหน่วยความจำของรูปพรีวิว — object URL ไม่หายเองจนกว่าจะปิดแท็บ
    this.revokePreviews();
  }

  /** คืน object URL ของพรีวิวทั้งหมด (เอกสาร + รูปโปรไฟล์) */
  revokePreviews = () => {
    const { form } = this.state;
    Object.values(form.docs || {}).forEach((doc) => doc?.url && URL.revokeObjectURL(doc.url));
    if (form.picture?.url) URL.revokeObjectURL(form.picture.url);
  };

  /* กรอกไปแล้วบางส่วนแต่ยังไม่ได้ส่ง = ปิดแท็บทิ้งแล้วข้อมูลหายหมด ต้องเตือนก่อน
     (ข้อความเตือนกำหนดเองไม่ได้ เบราว์เซอร์ใช้ข้อความมาตรฐานของตัวเอง) */
  onLeave = (event) => {
    if (this.state.ref_code || !this.dirty()) return;
    event.preventDefault();
    event.returnValue = "";
  };

  dirty = () => {
    const { form } = this.state;
    return !!(
      form.name ||
      form.email ||
      form.phone ||
      form.line_id ||
      form.address ||
      form.picture ||
      form.bank ||
      form.bank_account_no ||
      form.bank_account_name ||
      Object.keys(form.docs || {}).length
    );
  };

  /* แก้อีเมลหลังยืนยัน OTP ไปแล้ว = การยืนยันเดิมใช้ไม่ได้ ต้องขอรหัสใหม่กับอีเมลใหม่
     ตัดตรงนี้ที่เดียว จะได้ไม่มีทางที่อีเมลในใบสมัครกับอีเมลที่ยืนยันเป็นคนละอัน */
  setForm = (patch) =>
    this.setState((state) => {
      // ตั๋วไม่ใช่ช่องในฟอร์ม — แยกออกมาเก็บไว้ที่ระดับหน้าตั้งแต่ตรงนี้
      const { apply_token, ...rest } = patch;
      patch = rest;

      const changedEmail = patch.email !== undefined && patch.email !== state.form.email;
      const form = { ...state.form, ...patch, ...(changedEmail ? { email_verified: false } : {}) };

      // ช่องไหนแก้แล้วให้ข้อความผิดพลาดของช่องนั้นหายไปทันที ไม่ต้องรอกด "ถัดไป" ใหม่
      const errors = { ...state.errors };
      Object.keys(patch).forEach((key) => delete errors[key]);
      if (patch.email_verified) delete errors.otp;
      if (patch.docs) delete errors.docs;

      return {
        form,
        errors,
        /* แก้อีเมลหลังยืนยันแล้ว = ตั๋วใบเดิมผูกกับอีเมลเก่า ใช้ส่งใบสมัครไม่ได้อีก
           (server เทียบอีเมลในตั๋วกับอีเมลในใบสมัครแล้วปฏิเสธถ้าไม่ตรง) ทิ้งทันที
           ไม่ปล่อยให้ค้างจนไปพังตอนกดส่ง */
        ...(changedEmail ? { apply_token: "" } : {}),
        ...(apply_token !== undefined ? { apply_token } : {}),
      };
    });

  validators = { profile: validateProfile, verify: validateVerify, terms: validateTerms };

  /* ตรวจเฉพาะขั้นที่อยู่ ถ้าไม่ผ่านให้ค้างที่เดิมพร้อมข้อความใต้ช่อง แล้วเลื่อนขึ้น
     ไปหาช่องแรกที่ผิด — ฟอร์มยาวกว่าหนึ่งหน้าจอ ถ้าไม่เลื่อนให้จะไม่เห็นว่าผิดตรงไหน */
  check = (step) => {
    const errors = (this.validators[step] || (() => ({})))(this.state.form);
    this.setState({ errors });
    if (Object.keys(errors).length) {
      setTimeout(() => {
        const target = document.querySelector(".hm-pt-card .is-error");
        if (target) target.scrollIntoView({ behavior: "smooth", block: "center" });
      }, 0);
      return false;
    }
    return true;
  };

  go = (step) => {
    this.setState({ step, errors: {} });
    // ขึ้นขั้นใหม่ต้องเริ่มอ่านจากหัวการ์ด ไม่ใช่ค้างอยู่ตรงปุ่มท้ายขั้นก่อนหน้า
    const card = document.querySelector(".hm-pt-card");
    window.scrollTo({ top: card ? card.offsetTop - 110 : 0, behavior: "smooth" });
  };

  next = () => {
    const { step } = this.state;
    if (!this.check(step)) return;
    const nextStep = PARTNER_STEPS[STEP_INDEX[step] + 1];
    if (nextStep) this.go(nextStep.key);
  };

  back = () => {
    const prevStep = PARTNER_STEPS[STEP_INDEX[this.state.step] - 1];
    if (prevStep) this.go(prevStep.key);
  };

  /* ย้อนกลับไปแก้ขั้นก่อนหน้า (จากแถบความคืบหน้า หรือปุ่ม "แก้ไข" ในหน้าตรวจทาน) */
  jump = (step) => {
    if (STEP_INDEX[step] >= STEP_INDEX[this.state.step]) return;
    this.go(step);
  };

  /**
   * อัปเอกสารทุกใบขึ้น R2 แล้วคืนรายการที่พร้อมแนบไปกับใบสมัคร
   *
   * ไล่ทีละใบ ไม่ยิงพร้อมกัน — ตอนนี้มีใบเดียวต่อชนิดเอกสารอยู่แล้ว และการยิงเรียง
   * ทำให้ข้อความผิดพลาดชี้ได้ว่าใบไหนพัง แทนที่จะได้ error ก้อนเดียวไม่รู้ว่าของใคร
   *
   * คืน null เมื่อมีใบใดใบหนึ่งอัปไม่สำเร็จ (ผู้เรียกหยุดทั้งการส่งใบสมัคร)
   * ไม่ส่งใบสมัครที่เอกสารขาด เพราะผู้ดูแลจะตรวจไม่ได้แล้วต้องตีกลับอยู่ดี
   */
  uploadDocs = async () => {
    const { form, apply_token } = this.state;
    const slots = DOC_SLOTS[form.doc_type] || [];
    const docs = [];

    for (const slot of slots) {
      const doc = (form.docs || {})[slot.key];
      if (!doc?.file) continue;

      const result = await uploadDocument(doc.file, apply_token);
      if (result?.status !== true) {
        // UPLOAD ไม่ได้เด้งข้อความเอง (ต่างจาก POST) จึงต้องแจ้งที่นี่
        await alert(
          "",
          "warning",
          t("warning"),
          `${t(slot.label)}\n${result?.message || t("partner_doc_upload_failed")}`,
          t("confirm")
        );
        return null;
      }

      docs.push({ slot: slot.key, ...result.data });
    }

    return docs;
  };

  /**
   * อัปรูปโปรไฟล์ขึ้น R2 แล้วคืน URL ที่ได้ (คืน "" เมื่อไม่ได้แนบรูปมา)
   *
   * คืน null เมื่ออัปไม่สำเร็จ แล้วผู้เรียกหยุดการส่งทั้งใบ — รูปไม่บังคับก็จริง แต่คนที่
   * เลือกรูปไว้แล้วย่อมคาดว่ารูปนั้นไปด้วย ปล่อยผ่านเงียบ ๆ คือส่งใบสมัครที่ไม่มีรูป
   * โดยเจ้าตัวไม่รู้ตัว ข้อความที่เด้งบอกทางออกไว้ด้วยว่าเอารูปออกแล้วส่งใหม่ได้เลย
   */
  uploadProfilePicture = async () => {
    const { form, apply_token } = this.state;
    if (!form.picture?.file) return "";

    const result = await uploadPicture(form.picture.file, apply_token);
    if (result?.status !== true) {
      // UPLOAD ไม่ได้เด้งข้อความเอง (ต่างจาก POST) จึงต้องแจ้งที่นี่
      await alert(
        "",
        "warning",
        t("warning"),
        `${result?.message || t("partner_picture_upload_failed")}\n${t("partner_picture_upload_hint")}`,
        t("confirm")
      );
      return null;
    }

    return result.data?.file_path || "";
  };

  /* ส่งใบสมัคร : อัปเอกสาร → POST partner/apply → รับเลขที่ใบสมัครจริงจากหลังบ้าน */
  Save = async () => {
    if (this.state.sending) return;

    /* ตรวจทั้งใบอีกครั้งก่อนส่ง — ย้อนกลับไปแก้ขั้นแรกแล้วลบค่าที่จำเป็นทิ้งได้
       ถ้าไม่ผ่านให้พากลับไปยังขั้นแรกที่มีปัญหา ไม่ใช่แค่ขึ้นข้อความเฉย ๆ */
    const broken = firstInvalidStep(this.state.form);
    if (broken) {
      await alert("", "warning", t("warning"), t("partner_fix_errors"), t("confirm"));
      this.setState({ step: broken }, () => this.check(broken));
      return;
    }

    /* ไม่มีตั๋ว = การยืนยันอีเมลหมดอายุหรือถูกล้างไปเพราะเปลี่ยนอีเมล
       พากลับไปยืนยันใหม่เลย ดีกว่าปล่อยให้ยิงไปแล้วโดน server ปฏิเสธ */
    if (!this.state.apply_token) {
      await alert("", "warning", t("warning"), t("partner_ticket_expired"), t("confirm"));
      this.setState({ step: "verify" }, () => this.check("verify"));
      return;
    }

    /* จุดที่ย้อนกลับไม่ได้ — ส่งแล้วผู้สมัครแก้ไขเองไม่ได้ ต้องติดต่อผู้ดูแลระบบ
       ถามยืนยันหลังตรวจฟอร์มและตั๋วผ่านแล้ว จะได้ไม่ถามซ้ำกับใบที่ยังส่งไม่ได้อยู่ดี */
    if (!(await alert("", "question", t("partner_confirm_title"), t("partner_confirm_desc"), t("confirm"), t("cancel")))) return;

    this.setState({ sending: true });
    loading(true);

    const docs = await this.uploadDocs();
    if (!docs) {
      loading(false);
      this.setState({ sending: false });
      return;
    }

    /* รูปโปรไฟล์อัปทีหลังเอกสาร — เอกสารเป็นของบังคับ ถ้ามันพังก็จบตั้งแต่ตรงนั้น
       ไม่ต้องเสียเวลาอัปรูปที่ไม่บังคับขึ้นไปให้ค้างในบักเก็ตโดยไม่มีใบสมัครผูกอยู่ */
    const picture = await this.uploadProfilePicture();
    if (picture === null) {
      loading(false);
      this.setState({ sending: false });
      return;
    }

    const result = await applyPartner(toApplyPayload(this.state.form, this.state.apply_token, docs, picture));
    loading(false);
    this.setState({ sending: false });

    // POST เด้งข้อความจาก API ให้แล้วเมื่อไม่สำเร็จ จึงไม่ต้องเตือนซ้ำ
    if (result?.status !== true) return;

    /* ส่งสำเร็จแล้ว = ตั๋วใช้หมดหน้าที่ ทิ้งทันที ไม่เก็บไว้ในหน้าต่อ
       และล้างไฟล์ที่แนบไว้ออกจากหน่วยความจำด้วย (ไม่ต้องใช้พรีวิวอีกแล้ว) */
    this.revokePreviews();

    this.setState(
      {
        apply_token: "",
        form: { ...this.state.form, docs: {}, picture: null, password: "", password_confirm: "" },
        ref_code: result.data?.code || "",
        step: "done",
      },
      () => window.scrollTo({ top: 0, behavior: "smooth" })
    );
  };

  /* คัดลอกเลขที่ใบสมัคร — ใช้ clipboard ตรง ๆ ไม่ผ่าน copyText() ของโปรเจกต์
     เพราะตัวนั้นเด้งป๊อปอัปภาษาอังกฤษของมันเอง หน้าฝั่งลูกค้าต้องตามภาษาที่เลือก */
  copyRef = async (value) => {
    try {
      await navigator.clipboard.writeText(value);
      alert("", "success", t("success"), t("partner_done_copied"), t("confirm"));
    } catch (error) {
      alert("", "warning", t("warning"), t("partner_done_copy_failed"), t("confirm"));
    }
  };

  soon = (name) => alert("", "info", t("coming_soon_title"), `${name} — ${t("coming_soon_desc")}`, t("confirm"));

  renderStep = () => {
    const { step, form, errors, ref_code } = this.state;

    if (step === "verify") {
      return (
        <PartnerVerify
          form={form}
          errors={errors}
          onChange={this.setForm}
          onEditEmail={() => this.jump("profile")}
        />
      );
    }
    if (step === "terms") {
      return <PartnerTerms form={form} errors={errors} onChange={this.setForm} onEdit={this.jump} />;
    }
    if (step === "done") {
      return <PartnerDone form={form} refCode={ref_code} onCopy={this.copyRef} />;
    }
    return <PartnerProfile form={form} errors={errors} onChange={this.setForm} />;
  };

  render() {
    const { step, form, sending } = this.state;
    const index = STEP_INDEX[step];
    const isDone = step === "done";
    const isLast = step === "terms";

    /* ปุ่มส่งใบสมัครเปิดต่อเมื่อยอมรับครบทั้งสองข้อ — ข้อกำหนดการเป็นพาร์ตเนอร์
       (ข้อตกลงทางธุรกิจ) และความยินยอมข้อมูลส่วนบุคคล (ฐานทางกฎหมายในการเก็บ
       สำเนาเอกสาร) ขาดข้อใดข้อหนึ่งก็รับใบสมัครไม่ได้ */
    const accepted = form.accept_terms && form.accept_pdpa;
    const blocked = isLast && !accepted;

    return (
      <div className="mn-home">
        <HomeNavbar onPost={openFreePost} />

        <section className="hm-pt">
          <div className="hm-container">
            <div className="hm-pt__head">
              <span className="hm-pt__kicker">{t("partner_kicker")}</span>
              <h1 className="hm-pt__title">{t("partner_title")}</h1>
              <p className="hm-pt__desc">{t("partner_desc")}</p>
            </div>

            <div className="hm-pt__layout">
              <div className="hm-pt__main">
                <PartnerStepper current={step} done={isDone} onJump={this.jump} />

                <div className="hm-pt-card">
                  {!isDone && (
                    <div className="hm-pt-card__head">
                      <span className="hm-pt-card__count">
                        {t("partner_step_of").replace("{n}", index + 1).replace("{total}", PARTNER_STEPS.length - 1)}
                      </span>
                      <h2 className="hm-pt-card__title">{t(PARTNER_STEPS[index].label)}</h2>
                      <p className="hm-pt-card__desc">{t(PARTNER_STEPS[index].desc)}</p>
                    </div>
                  )}

                  <div className="hm-pt-card__body">{this.renderStep()}</div>

                  {!isDone && (
                    <div className="hm-pt-card__foot">
                      {/* ปุ่มถูกปิดอยู่ต้องบอกเหตุผลด้วย ไม่งั้นผู้ใช้จะกดแล้วงงว่าทำไมไม่มีอะไรเกิดขึ้น */}
                      <span className={`hm-pt-card__required ${blocked ? "is-blocked" : ""}`}>
                        {blocked ? t("partner_accept_note") : <><i aria-hidden="true">*</i> {t("partner_required_note")}</>}
                      </span>
                      <div className="hm-pt-card__actions">
                        {index > 0 && (
                          <button type="button" className="hm-btn hm-btn--ghost" onClick={this.back} disabled={sending}>
                            <span className="hm-ico">{ICON.chevron_left}</span>
                            {t("partner_back")}
                          </button>
                        )}
                        <button
                          type="button"
                          className="hm-btn hm-btn--primary"
                          onClick={isLast ? this.Save : this.next}
                          disabled={sending || blocked}
                        >
                          {isLast ? (sending ? t("partner_submitting") : t("partner_submit")) : t("partner_next")}
                          <span className="hm-ico">{isLast ? ICON.check : ICON.chevron_right}</span>
                        </button>
                      </div>
                    </div>
                  )}
                </div>
              </div>

              {/* แถบข้างบอกว่าสมัครแล้วได้อะไร + ติดต่อใครถ้าติดปัญหา
                  อยู่ติดหน้าจอตอนเลื่อน เพราะฟอร์มยาวกว่าหนึ่งหน้าจอ */}
              <aside className="hm-pt__side">
                <div className="hm-pt-aside">
                  <div className="hm-pt-aside__title">{t("partner_benefit_title")}</div>
                  <ul className="hm-pt-aside__list">
                    {["partner_benefit_1", "partner_benefit_2", "partner_benefit_3", "partner_benefit_4"].map((key) => (
                      <li key={key}>
                        <span className="hm-ico">{ICON.check}</span>
                        {t(key)}
                      </li>
                    ))}
                  </ul>
                </div>

                <div className="hm-pt-aside hm-pt-aside--tint">
                  <div className="hm-pt-aside__title">
                    <span className="hm-ico">{ICON.headset}</span>
                    {t("partner_help_title")}
                  </div>
                  <p className="hm-pt-aside__desc">{t("partner_help_desc")}</p>
                  <button type="button" className="hm-btn hm-btn--ghost hm-btn--sm" onClick={openFreePost}>
                    <span className="hm-ico">{ICON.comment}</span>
                    {t("partner_help_cta")}
                  </button>
                </div>

                {/* เคยส่งใบสมัครไปแล้วแต่กลับเข้ามาที่หน้าสมัครอีก — คนกลุ่มนี้มาหา
                    "ใบเดิมถึงไหนแล้ว" ไม่ได้มากรอกใหม่ พาไปหน้าติดตามสถานะเลย
                    ซ่อนตอน done เพราะจอนั้นมีปุ่มติดตามที่พ่วงเลขที่ใบสมัครให้อยู่แล้ว */}
                {!isDone && (
                  <div className="hm-pt-aside">
                    <div className="hm-pt-aside__title">{t("partner_applied_title")}</div>
                    <p className="hm-pt-aside__desc">{t("partner_applied_desc")}</p>
                    <button
                      type="button"
                      className="hm-btn hm-btn--ghost hm-btn--sm"
                      onClick={() => openPartnerStatus(this.props.router.navigate)}
                    >
                      <span className="hm-ico">{ICON.search}</span>
                      {t("partner_done_track")}
                    </button>
                  </div>
                )}
              </aside>
            </div>
          </div>
        </section>

        <HomeFooter
          data={{}}
          socials={[]}
          onLink={(key) => this.soon(t(key))}
          onSubscribe={() => this.soon(t("home_footer_subscribe"))}
        />
      </div>
    );
  }
}

export default withRouter(PartnerApply);
